import { TranslationId } from 'app/modules/settings/domain/valueObject/TranslationId';
import { TranslationLanguage } from 'app/modules/settings/domain/valueObject/TranslationLanguage';
import { TranslationText } from 'app/modules/settings/domain/valueObject/TranslationText';
import { BannerParam } from 'app/modules/settings/domain/entity/BannerParam';

export class Translation {

    private readonly _id: TranslationId;
    private readonly _language: TranslationLanguage;
    private readonly _text: TranslationText;
    private readonly _link: URL|null;
    private readonly _fixedText: string|null;
    private readonly _fixedTextParams: BannerParam[]|null;
    private readonly _resolvedFixedText: string|null;

    public constructor(
        id:TranslationId,
        language:TranslationLanguage,
        text:TranslationText,
        link:URL|null,
        fixedText:string|null = null,
        fixedTextParams:BannerParam[]|null = null,
        resolvedFixedText:string|null = null,
    ) {
        this._id = id;
        this._language = language;
        this._text = text;
        this._link = link;
        this._fixedText = fixedText;
        this._fixedTextParams = fixedTextParams;
        this._resolvedFixedText = resolvedFixedText;
    }

    public get id(): TranslationId {
        return this._id;
    }

    public get language(): TranslationLanguage {
        return this._language;
    }

    public get text(): TranslationText {
        return this._text;
    }

    public get link(): URL|null {
        return this._link;
    }

    public get fixedText(): string|null {
        return this._fixedText;
    }

    public get fixedTextParams(): BannerParam[]|null {
        return this._fixedTextParams;
    }

    public get resolvedFixedText(): string|null {
        return this._resolvedFixedText;
    }

}
